import { autoinject, bindable, PLATFORM } from 'aurelia-framework';
import { I18N } from 'aurelia-i18n';
import { Tab } from 'elements/tabs/MnTabs';
import { AsyncErrorHandler, ViewLoadingFader } from 'lib/ui';
import { MooringProductionOrderDto } from 'models/mooring';
import { MooringProductionOrderService } from 'services/mooring';
import { ProductionOrderDetailsDialog } from './production-order-details-dialog';
import { DialogService } from 'aurelia-dialog';
import './production-order-view.scss';
@autoinject
export class ProductionView {
  @bindable productionOrderId: number;

  protected productionOrder: MooringProductionOrderDto;

  protected tabsReady = false;
  protected tabs: Tab[] = [
    {
      name: 'overview',
      title: this.t.tr('general.overview'),
      view: PLATFORM.moduleName('views/mooring/mooring-production-orders/production-order/overview/tab'),
      data: {},
    },
    {
      name: 'anchor-lines',
      title: this.t.tr('mooring.anchorLine_plural'),
      view: PLATFORM.moduleName('views/mooring/mooring-production-orders/production-order/anchor-lines/tab'),
      guard: false,
      data: {},
    },
    {
      name: 'grid-lines',
      title: this.t.tr('mooring.gridLine_plural'),
      view: PLATFORM.moduleName('views/mooring/mooring-production-orders/production-order/grid-lines/tab'),
      guard: false,
      data: {},
    },
    {
      name: 'buoys',
      title: this.t.tr('mooring.buoy_plural'),
      view: PLATFORM.moduleName('views/mooring/mooring-production-orders/production-order/buoys/tab'),
      guard: false,
      data: {},
    },
    {
      name: 'bridles',
      title: this.t.tr('mooring.bridle_plural'),
      view: PLATFORM.moduleName('views/mooring/mooring-production-orders/production-order/bridles/tab'),
      guard: false,
      data: {},
    },
    // {
    //   name: 'cages',
    //   title: this.t.tr('mooring.floater_plural'),
    //   view: PLATFORM.moduleName('views/mooring/mooring-production-orders/production-order/anchor-lines/tab'),
    //   guard: false,
    //   data: {},
    // },
    {
      name: 'fleet-anchor-lines',
      title: this.t.tr('mooring.fleetAnchorLine_plural'),
      view: PLATFORM.moduleName('views/mooring/mooring-production-orders/production-order/fleet-anchor-lines/tab'),
      guard: false,
      data: {},
    },
    {
      name: 'delivery',
      title: this.t.tr('mooring.delivery'),
      view: PLATFORM.moduleName('views/mooring/mooring-production-orders/production-order/delivery/tab'),
      data: {},
    },
    {
      name: 'hours',
      title: this.t.tr('general.hours'),
      view: PLATFORM.moduleName('views/mooring/mooring-production-orders/production-order/hours/tab'),
      data: {},
    },
  ] as const;

  constructor(
    private readonly element: Element,
    private t: I18N,
    private mooringProductionOrderService: MooringProductionOrderService,
    private dialogService: DialogService
  ) {}

  activate(params: { id: number }) {
    this.productionOrderId = params.id;
    void this.init();
  }

  @ViewLoadingFader
  attached() {}

  async init() {
    await this.getProductionOrder();

    for (const tab of this.tabs) {
      if (!tab.data) tab.data = {};
      tab.data = {
        productionOrderId: this.productionOrderId,
        mooringId: this.productionOrder.MooringId,
      };
    }

    this.tabsReady = true;
  }

  @AsyncErrorHandler
  async getProductionOrder() {
    const { data } = await this.mooringProductionOrderService.getProductionOrder(this.productionOrderId);
    this.productionOrder = data;
  }

  protected editDetails() {
    void this.dialogService.open({
      viewModel: ProductionOrderDetailsDialog,
      model: {
        id: this.productionOrderId,
      },
    });
  }
}
